<template>
	<div class="container">
		<van-sticky>
			<navbar :title="titleList[type]" />
		</van-sticky>

		<div v-if="type == 0">
			<van-panel
				class="recording-panel"
				v-for="(item, index) in recordingList"
				:key="index"
				:title="item.product_name"
			>
				<div>
					<van-cell title="批号" :value="item.inbound_ph" />
					<van-cell title="出库数量" :value="item.quantity" />
					<van-cell title="物流公司" :value="item.logistics_name" />
					<van-cell title="物流单号" :value="item.logistics_number" />
					<van-cell title="出库日期" :value="item.outbound_date" />
				</div>
			</van-panel>
		</div>

		<div v-else-if="type == 1">
			<van-panel
				class="recording-panel"
				v-for="(item, index) in recordingList"
				:key="index"
				:title="item.credit_account"
				:desc="item.credit_remark"
			>
				<div>
					<van-cell title="是否确认" :value="item.credit_status==0?'未确认':'已确认'" />
					<van-cell title="日期" :value="item.credit_date" />
				</div>
			</van-panel>
		</div>

		<div v-else>
			<van-panel
				class="recording-panel"
				v-for="(item, index) in recordingList"
				:key="index"
				:title="item.order_name"
				:desc="item.credit_remark"
			>
				<div>
					<van-cell title="是否确认" :value="check_status[item.check_status]" />
					<van-cell title="申请日期" :value="item.create_date" />
					<van-cell title="退货数量" :value="item.recede_quantity" />
					<van-cell title="退款金额" :value="item.amount" />
					<van-cell title="实际退款金额" :value="item.recede_amount" />
					<van-cell title="其他费用退货数量" :value="item.other_fee_quantity" />
					<van-cell title="其他费用退款金额" :value="item.other_fee_quantity_amount" />
				</div>
			</van-panel>
		</div>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/order";
import { Toast } from "vant";

export default {
	components: {
		navbar
	},
	data() {
		return {
			activeName: "index",
			order_id: this.$route.query.id,
			type: this.$route.query.type,
			titleList: ["出库记录", "收款记录", "退货记录"],
			requestType: [
				"outbound_records",
				"collection_records",
				"return_record"
			],
			recordingList: [],
			check_status: ["董事长", "仓库审批", "财务", "通过", "拒绝"]
		};
	},
	mounted() {
		this.getRecording();
	},
	methods: {
		getRecording() {
			post({
				requestType: this.requestType[this.type],
				order_id: this.order_id
			})
				.then(res => {
					console.log(res);
					this.recordingList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.recording-panel {
	margin-top: 10px;
}
</style>
